import React, { ReactNode } from 'react';
import { Box, Container } from '@mui/material';

interface ComponentContainerProps {
    children?: ReactNode,
    contentful_id : string,
    sx ?: Object,
    fullWidth ?: Boolean,
    [key: string]: any;
};

export const ComponentInnerContainer = ({children} : {children : ReactNode}) => (
    <Container maxWidth="lg">
        {children}
    </Container>
);

export const ComponentContainer : React.FC<ComponentContainerProps> = ({children, contentful_id, fullWidth = false, sx = {}, ...props}) => (
    <Box data-sb-object-id={contentful_id} {...props} sx={{px:2,py:2,position:'relative',...sx}}>
        {
            fullWidth
                ? <Box>{children}</Box>
                : <ComponentInnerContainer>{children}</ComponentInnerContainer>
        }
    </Box>
);

export default ComponentContainer;
